// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const morpeko_hangry: PokeData = {
  "id": 10187,
  "name": "morpeko-hangry",
  "height": 3,
  "weight": 30,
  "base_experience": 153,
  "types": [
    PokeType.ELECTRIC,
    PokeType.DARK
  ],
  "api_moves": [
    "thrash",
    "tail-whip",
    "leer",
    "bite",
    "thunder-shock",
    "agility",
    "quick-attack",
    "spark",
    "crunch",
    "torment",
    "flatter",
    "bullet-seed",
    "power-trip",
    "aura-wheel"
  ],
  "moves": [
    "leer",
    "bite",
    "thunder-shock",
    "quick-attack",
    "crunch",
    "flatter",
    "bullet-seed",
    "dark-pulse",
    "night-daze",
    "electric-terrain",
    "volt-switch",
    "lash-out",
    "snarl"
  ],
  "evolution_chain": {
    "id": 459,
    "item": null,
    "species": [
      {
        "name": "morpeko",
        "order": 877,
        "types": [
          PokeType.ELECTRIC,
          PokeType.DARK
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      }
    ]
  },
  "stats": {
    "resistance": 93,
    "speed": 155,
    "ability_power": 152
  },
  "stat_changes": [],
  "catch_rate": 180,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
